import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { SearchTextField } from "../../../components/TextField";
import { useTablesStyle } from "../../../styles/tableStyle";
const UsersGroupTable = () => {
  const tableStyle = useTablesStyle();
  return (
    <Grid item container xs={12}>
      <Grid item xs={12}>
        <Grid item xs={12} sm={8}>
          <SearchTextField />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TableContainer className={tableStyle.tableContainer}>
          <Table>
            <TableHead>
              <TableRow className={tableStyle.TableRow}>
                {TableHeadCells.map((item) => {
                  return (
                    <TableCell width={item.width} key={item.title}>
                      {item.title}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={tableStyle.TableRow}></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default UsersGroupTable;
const TableHeadCells = [
  { title: "شناسه", width: "20%" },
  { title: "نام گروه کاربران", width: "60%" },
  { title: "عملیات", width: "20%" },
];
